import { BASE_URL, EMPLOYEE_WORKSHOP_ASSESSMENT, GET_ASSESSMENT_RESULT, WORKSHOP_ASSESSMENTS } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IAnswer } from "models/EmployeeWorkshopAssessment";

export async function getWorkshopAssessment(params: string = "") {
  const response = await axios.get(BASE_URL + WORKSHOP_ASSESSMENTS + params);
  return response.data;
}

export async function getEmployeeWorkshopAssessment(params: string = "") {
  const response = await axios.get(BASE_URL + EMPLOYEE_WORKSHOP_ASSESSMENT + params);
  return response.data;
}

export async function addEmployeeAssessment(id: string) {
  const response = await axios.post(BASE_URL + EMPLOYEE_WORKSHOP_ASSESSMENT + '?workshopAssessmentId=' + id);
  return response.data;
};

export async function addEmployeeAnswer(data: IAnswer, id: string) {
  const response = await axios.post(BASE_URL + EMPLOYEE_WORKSHOP_ASSESSMENT + '/addanswer?workhopAssessmentId=' + id, data);
  return response.data;
};

export async function updateElapsedTime(id: string) {
  const response = await axios.patch(BASE_URL + EMPLOYEE_WORKSHOP_ASSESSMENT + '/' + id);
  return response.data;
};

export async function updateAssessmentStatus(id: string) {
  const response = await axios.patch(BASE_URL + EMPLOYEE_WORKSHOP_ASSESSMENT + '/employeefinishassessment?id=' + id);
  return response.data;
};

export async function unfinishAssessment(id: string) {
  const response = await axios.patch(BASE_URL + EMPLOYEE_WORKSHOP_ASSESSMENT + '/unfinishassessment?id=' + id);
  return response.data;
};

export async function resetAssessment(id: string) {
  const response = await axios.patch(BASE_URL + EMPLOYEE_WORKSHOP_ASSESSMENT + '/resetassessment?id=' + id);
  return response.data;
};

export async function getAssessmentResult(assessmentDefinitionId: string) {
  const response = await axios.get(BASE_URL + GET_ASSESSMENT_RESULT(assessmentDefinitionId));
  return response.data;
};

export const EmployeeWorkshopAssessmentsCells: HeadCell[] = [

  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "T_title",
  },
  {
    id: "type",
    numeric: false,
    disablePadding: false,
    label: "T_type",
  },
  {
    id: "timeToComplete",
    numeric: true,
    disablePadding: false,
    label: "T_time_to_complete",
  },
  {
    id: "numberOfQuestions",
    numeric: false,
    disablePadding: false,
    label: "T_number_of_questions",
  },
  {
    id: "completed",
    numeric: false,
    disablePadding: false,
    label: "T_status",
  },
  {
    id: "id",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  }
];

